<template>
  <button :class="classes" @click="$emit('button-click')">
    <slot />
    <v-icon v-if="icon" :icon="icon" :ratio="0.5" />
  </button>
</template>

<script>
/* eslint-disable */
import VIcon from "../icon/Icon";

export default {
  name: "v-button",
  components: {
    VIcon
  },
  props: {
    size: { type: String, default: "medium" },
    variant: { type: String, default: "default" },
    intent: { type: String, default: "primary" },
    icon: { type: String },
    iconTransition: { type: String }
  },
  computed: {
    classes() {
      let classes = ["v-button"];

      classes.push("size-" + this.size);
      classes.push("variant-" + this.variant);
      classes.push("intent-" + this.intent);

      // Icon
      if (this.iconTransition) {
        classes.push("icon-transition-" + this.iconTransition);
      }

      return classes;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../design/variables.scss";

.v-button {
  outline: 0;
  cursor: pointer;
  transition: all ease-in-out 300ms;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  border-radius: 4px;
  text-transform: uppercase;
  white-space: nowrap;
  min-width: 96px;
  letter-spacing: 0.02rem;

  &[disabled] {
    opacity: 0.3;
    cursor: default;
  }

  // Sizing
  &.size-small {
    padding: 9px 16px;
    font-size: 0.75rem;
    line-height: 20px;
  }
  &.size-medium {
    padding: 12px 24px;
    font-size: 0.875rem;
    line-height: 22px;
  }
  &.size-large {
    padding: 23px 40px;
    font-size: 1rem;
    line-height: 24px;
  }

  // Variants
  &.variant-default {
    border-width: 1px;
    border-style: solid;

    &.intent-primary {
      border-color: map-deep-get($colors, "brand", "primary");
      background-color: map-deep-get($colors, "brand", "primary");
      color: #fff;

      &:hover {
        background-color: map-deep-get($colors, "foreground", "primary");
        border-color: map-deep-get($colors, "foreground", "primary");
      }

      &[disabled] {
        border-color: map-deep-get($colors, "brand", "primary");
        background-color: map-deep-get($colors, "brand", "primary");
      }
    }

    &.intent-secondary {
      background-color: map-deep-get($colors, "foreground", "primary");
      border-color: map-deep-get($colors, "foreground", "primary");
      color: #fff;
      &:hover {
        border-color: map-deep-get($colors, "brand", "primary");
        background-color: map-deep-get($colors, "brand", "primary");
      }

      &[disabled] {
        background-color: map-deep-get($colors, "foreground", "primary");
        border-color: map-deep-get($colors, "foreground", "primary");
      }
    }

    &.intent-destructive {
      background-color: map-deep-get($colors, "foreground", "alert");
      border-color: map-deep-get($colors, "foreground", "alert");
      color: #fff;
      &:hover {
        border-color: map-deep-get($colors, "foreground", "primary");
        background-color: map-deep-get($colors, "foreground", "primary");
      }

      &[disabled] {
        background-color: map-deep-get($colors, "foreground", "alert");
        border-color: map-deep-get($colors, "foreground", "alert");
      }
    }
  }

  &.variant-outline {
    border-width: 1px;
    border-style: solid;
    background-color: transparent;

    &.intent-primary {
      border-color: map-deep-get($colors, "brand", "primary");
      color: map-deep-get($colors, "brand", "primary");

      &:hover {
        background-color: map-deep-get($colors, "brand", "primary");
        color: #fff;
      }
      &[disabled] {
        background-color: transparent;
        color: map-deep-get($colors, "brand", "primary");
      }
    }

    &.intent-secondary {
      border-color: map-deep-get($colors, "foreground", "primary");
      &:hover {
        background-color: map-deep-get($colors, "foreground", "primary");
        color: #fff;
      }
      &[disabled] {
        background-color: transparent;
        color: map-deep-get($colors, "foreground", "primary");
      }
    }

    &.intent-destructive {
      color: map-deep-get($colors, "foreground", "alert");
      border-color: map-deep-get($colors, "foreground", "alert");
      &:hover {
        background-color: map-deep-get($colors, "foreground", "alert");
        color: #fff;
      }
      &[disabled] {
        background-color: transparent;
        color: map-deep-get($colors, "foreground", "alert");
      }
    }
  }

  &.variant-text {
    background-color: transparent;
    border-color: transparent;

    &.intent-primary {
      color: map-deep-get($colors, "brand", "primary");
      &:hover {
        color: map-deep-get($colors, "foreground", "action");
      }
      &[disabled] {
        color: map-deep-get($colors, "brand", "primary");
      }
    }

    &.intent-secondary {
      color: map-deep-get($colors, "foreground", "primary");
      &:hover {
        color: map-deep-get($colors, "brand", "primary");
      }
      &[disabled] {
        color: map-deep-get($colors, "foreground", "primary");
      }
    }

    &.intent-destructive {
      color: map-deep-get($colors, "foreground", "alert");
      &:hover {
        color: map-deep-get($colors, "foreground", "primary");
      }
      &[disabled] {
        color: map-deep-get($colors, "foreground", "primary");
      }
    }
  }

  .v-icon {
    margin-left: 4px;
    transition: transform 300ms ease-in-out;
  }
  &.icon-transition-right:hover .v-icon {
    transform: translateX(4px);
  }
}

// TODO: really redo all with inverted colors?
.theme-dark {
  .v-button {
    &.variant-outline {
      &.intent-primary {
        color: #fff;
        border-color: #fff;
        background-color: transparent;
        &:hover {
          background-color: #fff;
          color: map-deep-get($colors, "foreground", "primary");
        }
      }
    }
  }
}
</style>
